<template>
    <div class="home-rounded-cover overflow-hidden">
        <div class="cover-wrapper">
            <b-img
                class="cover-img"
                :src="src"
            />
            <div class="after" />
            <div class="centered">
                <h1
                    v-if="headline"
                    class="headline text-white"
                    v-html="refinedHeadline"
                >
                </h1>
                <p
                    v-if="subHeadline"
                    class="sub-headline text-white"
                >
                    {{ subHeadline }}
                </p>

                <div
                    class="d-flex flex-column flex-sm-row justify-content-center align-items-center"
                    :class="{'mt-5': !subHeadline}"
                >
                    <template v-for="(item,index) in actions">
                        <c-t-a-button
                            v-if="item.active"
                            :key="index"
                            :action="item"
                            :landing-page="landingPage"
                            variant="light"
                        />
                    </template>
                </div>

                <p
                    class="existing-client-sign-in"
                    v-if="existingClientSignIn"
                >
                    Existing Clients,

                    <b-link
                        class="sign-in"
                        :href="projects"
                    >
                        Sign In
                    </b-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import './HomeRoundedCover.scss';
    import './HomeRoundedCover.mobile.scss';
    import CTAButton from "../../CTAButton/CTAButton";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import {myProjectsUrl} from "../../../helpers/externalRoutes";

    export default {
        name: "HomeRoundedCover",
        components: {CTAButton},
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            },
            src: {
                type: String,
                required: true
            },
            headline: {
                type: String,
                default: ''
            },
            subHeadline: {
                type: String,
                default: ''
            },
            actions: {
                type: Array,
                default: () => []
            },

            existingClientSignIn: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            projects() {
                return myProjectsUrl({
                    brandedLogin: window.brandedLogin,
                });
            },
            refinedHeadline() {
                if(this.headline.includes('All for free!')) {
                    return this.headline.replace('All for free!','All for <u>free</u>!')
                }
                return this.headline;
            }
        }
    };
</script>
